import api from "../middlware/api";

const BASE = "/api/v1";

export const getAdminDashboard = () => api.get(`${BASE}/dashboard/admin`);
export const getDoctorDashboard = () => api.get(`${BASE}/dashboard/doctor`);
export const getFrontdeskDashboard = () => api.get(`${BASE}/dashboard/frontdesk`);
export const getNursingDashboard = () => api.get(`${BASE}/dashboard/nursing`);
